const DIESEL_RATE_KEY = 'advait_diesel_rate';
const DEFAULT_DIESEL_RATE = 97;

export function getDieselRate() {
  const stored = localStorage.getItem(DIESEL_RATE_KEY);
  if (stored === null || stored === '') {
    return DEFAULT_DIESEL_RATE;
  }
  const rate = parseFloat(stored);
  return Number.isFinite(rate) && rate > 0 ? rate : DEFAULT_DIESEL_RATE;
}

export function setDieselRate(rate) {
  const value = parseFloat(rate);
  if (!Number.isFinite(value) || value <= 0) {
    throw new Error('Diesel rate must be a positive number');
  }
  localStorage.setItem(DIESEL_RATE_KEY, String(value));
  window.dispatchEvent(new CustomEvent('settingsUpdated', {
    detail: { dieselRate: value }
  }));
  return value;
}

export { DEFAULT_DIESEL_RATE, DIESEL_RATE_KEY };
